import { render } from "./MyFollowingPage.vue?vue&type=template&id=2fbba206&scoped=true"
import script from "./MyFollowingPage.vue?vue&type=script&lang=js"
export * from "./MyFollowingPage.vue?vue&type=script&lang=js"

import "./MyFollowingPage.vue?vue&type=style&index=0&id=2fbba206&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbba206"]])

export default __exports__